/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  CardContent,
  Checkbox,
  Collapse,
  FormControl,
  FormControlLabel,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import { ExpandMore } from "@mui/icons-material";
import { Button } from "react-bootstrap";
import {
  getQuestionTags,
  getCodingQuestionByID,
  getCodingQuestionLanguages,
  getCodingQuestionReturnTypes,
  getQuestionLevels,
  postCreateCodingQuestion,
  postUpdateCodingQuestion,
  resetCodingQuestionById,
  uploadCodingQuestionFile,
  getQuestionTypes,
  resetQuestion,
  resetOptions,
  clearCreateQuestionState,
} from "../../Redux/ActionCreators/testLibraryAction";
import JoditEditor from "jodit-react";
import { returnErrors } from "../../Redux/ActionCreators/errorAction";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import {
  emptyTopics,
  getSkills,
  getSkillTopics,
} from "../../Redux/ActionCreators/myTestsAction";
import metricCategoriesData from "../../utils/metric_categoriees.json";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/ace";
import "ace-builds/src-noconflict/theme-github";
import "ace-builds/src-noconflict/mode-sql";
import ace from "ace-builds/src-noconflict/ace";

ace.config.set("basePath", "/node_modules/ace-builds/src-noconflict");

const UI_STRINGS = {
  OUTPUT: "output",
  TIME: "time",
  DIFFICULTY: "difficulty",
};

const save_button_style = {
  backgroundColor: "var(--button-color)",
  color: "#fff",
  borderRadius: "12px",
  height: 48,
  border: "none",
  fontSize: 14,
  padding: "10px 30px",
  minWidth: 150,
  marginBottom: 50,
};

const SqlAceEditor = ({ value, onChange, readOnly, height }) => (
  <AceEditor
    mode="sql"
    theme="github"
    value={value}
    onChange={onChange}
    width="100%"
    height={height}
    fontSize={14}
    showPrintMargin={false}
    readOnly={readOnly}
    setOptions={{
      useWorker: false,
      showLineNumbers: true,
      tabSize: 2,
    }}
  />
);

const CreateCodingQuestion = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const isEmbedded = props?.embedded || props?.fromCreateQuestion || false;
  const currentEditMode = isEmbedded ? props?.editMode : location?.state?.edit;
  const currentViewMode = isEmbedded ? props?.viewMode : location?.state?.view;
  const isCreateMode = !currentEditMode && !currentViewMode;
  const isViewMode = currentViewMode === true;
  const currentDetail = isEmbedded
    ? props?.existingDetail
    : location?.state?.detail;
  const currentType = isEmbedded
    ? props?.questionTypeID
    : Number(location?.state?.questionTypeID) ||
    (currentDetail?.questionTypeID ?? null);

  const details = JSON.parse(localStorage.getItem("profileDetails"));
  const [funcName, setFuncName] = useState("");
  const [loading, setLoading] = useState(false);
  const descriptionEditorRef = useRef(null);
  const imageInputRef = useRef(null);
  const hydratedRef = useRef(false);
  const {
    questionLevel,
    qTags,
    codingQuestionReturnTypesOptions,
    codingQuestionLanguagesOptions,
    codingQuestionByIdResponse,
    loadingCodingQuestionById,
  } = useSelector((state) => state.testLibrary);
  const { skills, topics } = useSelector((state) => state.myTests);

  const [questionTitle, setQuestionTitle] = useState("");
  const [questionDescription, setQuestionDescription] = useState("");
  const [questionDescriptionError, setQuestionDescriptionError] = useState("");

  const [programmingLanguages, setProgrammingLanguages] = useState([]);
  const [tags, setTags] = useState([]);

  const [questionWeightage, setQuestionWeightage] = useState(20);

  const [timeDuration, setTimeDuration] = useState(10);

  const [selectOutput, setSelectOutput] = useState(1);

  const [selectDifficulty, setSelectDifficulty] = useState(1);

  const [inputs, setInputs] = useState([{ inputName: "n", inputTypeId: 1 }]);

  const [expanded, setExpanded] = useState(true);

  const [testCases, setTestCases] = useState([
    { isDefault: 1, output: "", inputs: [{ input: "" }] },
    { isDefault: 0, output: "", inputs: [{ input: "" }] },
  ]);

  const [sampleSolution, setSampleSolution] = useState("");
  const [configuration, setConfiguration] = useState("");
  const [dbTestCases, setDbTestCases] = useState([
    { sqlQuery: "", isSample: false },
  ]);
  const [selectedKnowledgeArea, setSelectedKnowledgeArea] = useState(null);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [evaluateFile, setEvaluateFile] = useState(null);
  const [evaluateColumns, setEvaluateColumns] = useState([]);
  const [targetColumn, setTargetColumn] = useState(null);
  const [idColumn, setIdColumn] = useState(null);
  const [starterNotebookUrl, setStarterNotebookUrl] = useState("");
  const [trainDatasetUrl, setTrainDatasetUrl] = useState("");
  const [testDatasetUrl, setTestDatasetUrl] = useState("");
  const [evaluateDatasetUrl, setEvaluateDatasetUrl] = useState("");
  const [selectedMetricType, setSelectedMetricType] = useState("");
  const [threshold, setThreshold] = useState(0);
  const [starterNotebookFile, setStarterNotebookFile] = useState(null);
  const [trainDatasetFile, setTrainDatasetFile] = useState(null);
  const [testDatasetFile, setTestDatasetFile] = useState(null);
  const [evaluateDatasetFile, setEvaluateDatasetFile] = useState(null);
  const [sampleOutputUrl, setSampleOutputUrl] = useState("");
  const [sampleOutputFile, setSampleOutputFile] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categoryDescription, setCategoryDescription] = useState("");
  const [availableMetrics, setAvailableMetrics] = useState([]);
  const [selectedMetric, setSelectedMetric] = useState(null);
  const [metricDescription, setMetricDescription] = useState("");
  const [isThresholdVisible, setIsThresholdVisible] = useState(false);
  const [metricLoaded, setMetricLoaded] = useState(false);
  const [resolvedType, setResolvedType] = useState(null);

  const getDescriptionValue = () => {
    const editor = descriptionEditorRef.current;
    if (editor?.isReady) {
      try {
        return editor.value ?? "";
      } catch (err) {
        return questionDescription ?? "";
      }
    }
    return questionDescription ?? "";
  };

  const updateDescriptionValue = (nextValue) => {
    const editor = descriptionEditorRef.current;
    if (editor?.isReady) {
      try {
        editor.value = nextValue;
      } catch (err) {
        // Ignore editor sync errors and rely on state update below.
      }
    }
    setQuestionDescription(nextValue);
    setQuestionDescriptionError("");
  };

  const appendDescriptionHtml = (html) => {
    const currentValue = getDescriptionValue();
    updateDescriptionValue(`${currentValue}${html}`);
  };

  const removeDescriptionPlaceholder = (html, placeholderId) => {
    if (!html || !placeholderId) return html;
    const wrapper = document.createElement("div");
    wrapper.innerHTML = html;
    const placeholder = wrapper.querySelector(`#${placeholderId}`);
    if (placeholder) placeholder.remove();
    return wrapper.innerHTML;
  };

  const replacePlaceholderWithImage = (html, placeholderId, imageUrl) => {
    const wrapper = document.createElement("div");
    wrapper.innerHTML = html;
    const placeholder = wrapper.querySelector(`#${placeholderId}`);
    const imgWrapper = document.createElement("p");
    const img = document.createElement("img");
    img.src = imageUrl;
    img.alt = "uploaded image";
    imgWrapper.appendChild(img);
    if (placeholder) {
      placeholder.replaceWith(imgWrapper);
    } else {
      wrapper.appendChild(imgWrapper);
    }
    return wrapper.innerHTML;
  };

  const handleImageButtonClick = () => {
    if (isViewMode) return;
    imageInputRef.current?.click();
  };

  const handleImageUpload = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;

    if (!file.type || !file.type.startsWith("image/")) {
      returnErrors(dispatch, "Only images are allowed", 400);
      return;
    }

    const placeholderId = `uploading-image-${Date.now()}-${Math.random()
      .toString(36)
      .slice(2, 8)}`;
    appendDescriptionHtml(
      `<p id="${placeholderId}" data-uploading-image="true">uploading...</p>`,
    );

    try {
      const res = await dispatch(uploadCodingQuestionFile(file));
      const imageUrl = res?.url;
      if (!imageUrl) {
        throw new Error("Upload failed");
      }

      const currentValue = getDescriptionValue();
      updateDescriptionValue(
        replacePlaceholderWithImage(currentValue, placeholderId, imageUrl),
      );
    } catch (err) {
      const currentValue = getDescriptionValue();
      updateDescriptionValue(
        removeDescriptionPlaceholder(currentValue, placeholderId),
      );
      returnErrors(dispatch, "Failed to upload image", 500);
    }
  };

  const downloadFile = async (url, fileName) => {
    try {
      const response = await fetch(url, {
        method: "GET",
      });
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("File download failed", error);
      returnErrors(dispatch, "Unable to download file", 500);
    }
  };

  const joditConfig = {
    toolbarInlineForSelection: true,
    toolbar: true,
    readonly: isViewMode,
    statusbar: false,
    showCharsCounter: false,
    showWordsCounter: false,
    height: 350,
    askBeforePasteFromWord: false,
    askBeforePasteHTML: false,
    defaultActionOnPaste: "insert_clear_html",
    defaultActionOnPasteFromWord: "insert_as_html",
    enableDragAndDropFileToEditor: true,
    removeButtons: ["eraser", "fullsize", "file", "video", "image"],
    extraButtons: isViewMode
      ? []
      : [
        {
          name: "uploadImage",
          tooltip: "Insert image",
          icon: "image",
          exec: handleImageButtonClick,
        },
      ],
  };

  useEffect(() => {
    dispatch(getQuestionTags());
  }, []);

  useEffect(() => {
    const type =
      props?.questionTypeID ??
      location?.state?.questionTypeID ??
      currentDetail?.questionTypeID;

    setResolvedType(Number(type));
  }, []);

  useEffect(() => {
    if (!skills || skills.length === 0) {
      dispatch(getSkills());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (loadingCodingQuestionById) return;
    if (!codingQuestionByIdResponse) return;

    const loadData = async () => {
      const { question } = codingQuestionByIdResponse;
      if (!question) return;

      setQuestionTitle(question?.name || "");
      setQuestionDescription(question?.description || "");
      setQuestionWeightage(question?.score || 0);
      setTimeDuration(question?.duration || 0);
      setSelectOutput(question?.outputReturnTypeId || 0);
      setSelectDifficulty(question?.difficultyLevelId || 1);
      setInputs(question?.inputs || []);
      setTags(question?.tags?.map((t) => ({ label: t, value: t })) || []);
      setFuncName(question?.functionName || "");

      if (question?.skillId && !hydratedRef.current) {
        hydratedRef.current = true;
        setSelectedKnowledgeArea({
          label: question.skillName || "",
          value: question.skillId,
        });
        setSelectedTopic({
          label: question.skillTopicName || "",
          value: question.skillTopicId,
        });
        dispatch(getSkillTopics(0, question.skillId));
      }

      if (question?.questionTypeID !== 13) {
        setProgrammingLanguages(
          (question?.languages || [])
            .filter((el) => el)
            .map((el) => ({
              label: el.displayLanguage,
              value: el.codingLanguageId,
            })),
        );

        if (question?.questionTypeID === 12 && question?.data) {
          try {
            const parsed = JSON.parse(question.data);

            setSampleSolution(parsed?.Solution || "");
            setConfiguration(parsed?.Configuration || "");
            setDbTestCases(
              parsed?.TestCases?.map((tc) => ({
                sqlQuery: tc?.SqlQuery || "",
                isSample: tc?.IsSample || false,
              })) || [{ sqlQuery: "", isSample: false }],
            );
          } catch (err) {
            console.error("Error parsing type12 data:", err);
          }
        } else {
          question?.testCases?.forEach((tc) => {
            tc.inputs?.sort((a, b) => a.id - b.id);
          });
          setTestCases(question?.testCases || []);
        }

        return;
      }

      if (question?.questionTypeID === 13 && question?.data) {
        try {
          const ds = JSON.parse(question.data);

          setStarterNotebookUrl(ds?.starter_notebook || "");
          setTrainDatasetUrl(ds?.datasets?.train || "");
          setTestDatasetUrl(ds?.datasets?.test || "");
          setEvaluateDatasetUrl(ds?.datasets?.evaluate || "");
          setSampleOutputUrl(ds?.datasets?.sample_output || "");

          if (ds?.datasets?.evaluate) {
            const cols = await extractCSVColumnsFromUrl(ds.datasets.evaluate);
            setEvaluateColumns(cols.map((c) => ({ label: c, value: c })));
          }

          // Read category
          if (ds.metric?.category) {
            const categoryObj = metricCategoriesData.metric_categories.find(
              (c) => c.category === ds.metric.category,
            );

            if (categoryObj) {
              setSelectedCategory({
                label: categoryObj.category,
                value: categoryObj.category,
              });

              setCategoryDescription(categoryObj.description);

              // FIX #3: Only auto-apply default threshold if threshold missing
              if (categoryObj.show_threshold) {
                if (ds.metric?.threshold !== undefined) {
                  setThreshold(ds.metric.threshold);
                } else {
                  setThreshold(categoryObj.default_threshold ?? 0.5);
                }
              } else {
                setThreshold(null);
              }

              setIsThresholdVisible(categoryObj.show_threshold);

              setAvailableMetrics(
                categoryObj.metrics.map((m) => ({
                  label: m.metric_name,
                  value: m.metric_code,
                  description: m.description,
                })),
              );
            }
          }

          // Metric selection
          if (ds.metric?.metric_type) {
            const categoryMetrics = metricCategoriesData.metric_categories.find(
              (c) => c.category === ds.metric.category,
            )?.metrics;

            const metricObj = categoryMetrics?.find(
              (m) => m.metric_code === ds.metric.metric_type,
            );

            if (metricObj) {
              setSelectedMetric({
                label: metricObj.metric_name,
                value: metricObj.metric_code,
                description: metricObj.description,
              });

              setSelectedMetricType(metricObj.metric_code);
              setMetricDescription(metricObj.description);
            }
          }

          // Threshold
          if (ds.metric?.threshold !== undefined) {
            setThreshold(ds.metric.threshold);
          }
        } catch (err) {
          console.error("Error parsing type13 data:", err);
        }
      }
    };

    if (!location.state?.edit) {
      resetStates();
    }
    loadData();
  }, [codingQuestionByIdResponse, loadingCodingQuestionById]);

  const handleBack = async () => {
    await dispatch(clearCreateQuestionState());
    navigate(-1);
  };

  const handleDbTestCaseChange = (index, value) => {
    setDbTestCases((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        sqlQuery: value,
      };
      return updated;
    });
  };

  const handleExpandClick = () => {
    setExpanded((expanded) => !expanded);
  };

  const handleSelectChange = (select_name, event) => {
    if (select_name === UI_STRINGS.OUTPUT) {
      setSelectOutput(event?.target?.value);
    }
    if (select_name === UI_STRINGS.DIFFICULTY) {
      setSelectDifficulty(event?.target?.value);
    }
  };
  const selectLanguage = async (e) => {
    if (e.some((el) => el.value === "all")) {
      await setProgrammingLanguages(
        codingQuestionLanguagesOptions?.map(
          (el) => [{ label: el.displayLanguage, value: el.id }][0],
        ),
      );
    } else {
      await setProgrammingLanguages(e);
    }
  };

  const handleTags = (e) => {
    console.log(e);
    setTags(e);
  };

  const handleInputs = (index, key, event) => {
    const value = event?.target?.value;
    let inputs_copy = [...inputs];
    inputs_copy[index][key] = value;
    setInputs(inputs_copy);
  };

  const handleTestCase = (case_index, input_index, key, event) => {
    const value = event?.target?.value;
    let testCases_copy = [...testCases];

    // Ensure inputs array has an element at input_index
    if (!testCases_copy[case_index].inputs[input_index]) {
      testCases_copy[case_index].inputs.push({ input: "" });
    }

    testCases_copy[case_index].inputs[input_index][key] = value;
    setTestCases(testCases_copy);
  };

  const defaultTestCaseChangeHandler = (case_index, event) => {
    let testCases_copy = [...testCases];
    testCases_copy?.forEach((test_case, index) => {
      if (case_index === index) {
        test_case.isDefault = 1;
      } else {
        test_case.isDefault = 0;
      }
    });
    setTestCases(testCases_copy);
  };

  const testCaseOutputChangeHandler = (case_index, event) => {
    const value = event?.target?.value;
    let testCases_copy = [...testCases];
    testCases_copy[case_index].output = value;
    setTestCases(testCases_copy);
  };

  const deleteInputHandler = (index) => {
    let inputs_copy = [...inputs];
    inputs_copy.splice(index, 1);
    setInputs(inputs_copy);
  };

  const validateInputOnBlur = (input, index) => {
    if (!input?.inputName) {
      deleteInputHandler(index);
    }
  };

  const validateForm = () => {
    if (currentType === 13) {
      if (!questionTitle) {
        returnErrors(dispatch, "Question name is required!", 500);
        return false;
      }

      if (!questionDescription) {
        returnErrors(dispatch, "Question description is required!", 500);
        return false;
      }

      if (!selectedKnowledgeArea) {
        returnErrors(dispatch, "Please select a Knowledge Area!", 500);
        return false;
      }

      if (!selectedTopic) {
        returnErrors(dispatch, "Please select a Topic!", 500);
        return false;
      }

      if (!timeDuration || timeDuration < 1) {
        returnErrors(dispatch, "Please enter valid duration!", 500);
        return false;
      }

      if (!questionWeightage || questionWeightage < 1) {
        returnErrors(dispatch, "Please enter valid score!", 500);
        return false;
      }

      // FILE VALIDATION
      if (!starterNotebookUrl) {
        returnErrors(
          dispatch,
          "Starter Notebook (.ipynb) file is required!",
          500,
        );
        return false;
      }

      if (!trainDatasetUrl) {
        returnErrors(dispatch, "Train Dataset (.csv) is required!", 500);
        return false;
      }

      if (!testDatasetUrl) {
        returnErrors(dispatch, "Test Dataset (.csv) is required!", 500);
        return false;
      }

      if (!evaluateDatasetUrl) {
        returnErrors(dispatch, "Evaluate Dataset (.csv) is required!", 500);
        return false;
      }

      if (!selectedCategory) {
        returnErrors(dispatch, "Please select a Category!", 500);
        return false;
      }

      // METRIC VALIDATION
      if (!selectedMetricType) {
        returnErrors(dispatch, "Please select Metric Type!", 500);
        return false;
      }

      if (isThresholdVisible && (threshold === null || threshold === "")) {
        returnErrors(dispatch, "Threshold is required!", 500);
        return false;
      }

      // Target Column - Mandatory ONLY in create mode
      if (!location.state?.edit) {
        if (!targetColumn || !targetColumn.value) {
          returnErrors(dispatch, "Please select Target Column!", 500);
          return false;
        }

        if (!idColumn || !idColumn.value) {
          returnErrors(dispatch, "Please select ID Column!", 500);
          return false;
        }
      }

      // Tags are still shown → keep required
      if (!tags || tags.length === 0) {
        returnErrors(dispatch, "Please add at least one tag!", 500);
        return false;
      }

      return true;
    }

    // Default validation (existing logic for other question types)
    if (!questionTitle) {
      returnErrors(dispatch, "Question name is required!", 500);
      return false;
    } else if (!questionDescription) {
      returnErrors(dispatch, "Question description is required!", 500);
      return false;
    } else if (!funcName && currentType === 7) {
      returnErrors(dispatch, "Function Name is required!", 500);
      return false;
    } else if (!selectOutput && currentType === 7) {
      returnErrors(dispatch, "Question output is required!", 500);
      return false;
    } else if (!timeDuration) {
      returnErrors(dispatch, "Question duration is required!", 500);
      return false;
    } else if (!selectDifficulty) {
      returnErrors(dispatch, "Question difficulty is required!", 500);
      return false;
    } else if (!questionWeightage) {
      returnErrors(dispatch, "Question score is required!", 500);
      return false;
    } else if (programmingLanguages?.length === 0 && currentType !== 13) {
      returnErrors(
        dispatch,
        "At least 1 programming language is required!",
        500,
      );
      return false;
    } else if (tags?.length === 0) {
      returnErrors(dispatch, "At least 1 tag is required!", 500);
      return false;
    } else if (inputs?.length === 0 && currentType === 7) {
      returnErrors(dispatch, "At least 1 input is required!", 500);
      return false;
    } else if (testCases?.length === 0 && currentType === 7) {
      returnErrors(dispatch, "At least 2 test cases are required!", 500);
      return false;
    } else if (!selectedKnowledgeArea) {
      returnErrors(dispatch, "Please select a Knowledge Area!", 500);
      return false;
    } else if (!selectedTopic) {
      returnErrors(dispatch, "Please select a Topic!", 500);
      return false;
    }

    // input validation (only for type 7)
    if (currentType === 7) {
      const invalidInput = inputs.some((input) => !input.inputName);
      if (invalidInput) {
        returnErrors(dispatch, "Input name can't be empty", 500);
        return false;
      }

      const emptyTestCase = testCases.some(
        (tc) => !tc.output || tc.inputs.every((inp) => !inp.input),
      );
      if (emptyTestCase) {
        returnErrors(dispatch, "Test case fields can't be empty", 500);
        return false;
      }
    }

    return true;
  };

  const stripHTML = (htmlString) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  const questionSaveHandler = async () => {
    await setLoading(true);
    const is_formValid = validateForm();
    let autoLanguages = [];
    if (currentType === 13) {
      autoLanguages = codingQuestionLanguagesOptions
        ?.filter((lang) => lang?.category?.id === 3)
        ?.map((lang) => ({ codingLanguageId: lang.id }));
    }
    if (is_formValid) {
      let request_data;
      if (currentType === 12) {
        request_data = {
          tenantId: parseInt(details?.tenentId),
          questionTypeID: currentType,
          name: questionTitle,
          description: questionDescription,
          outputReturnTypeId: 0,
          duration: timeDuration,
          difficultyLevelId: selectDifficulty,
          weightage: questionWeightage,
          functionName: "",
          inputs: [],
          testCases: [],
          tags: tags.map((el) => el.value),
          languages: programmingLanguages.map((el) => ({
            codingLanguageId: el.value,
          })),
          data: JSON.stringify({
            // Solution: stripHTML(sampleSolution),
            Solution: sampleSolution,
            Configuration: configuration,
            TestCases: dbTestCases.map((tc) => ({
              IsSample: tc.isSample,
              // SqlQuery: stripHTML(tc.sqlQuery),
              SqlQuery: tc.sqlQuery,
            })),
          }),
          skillId: selectedKnowledgeArea?.value || 0,
          skillTopicId: selectedTopic?.value || 0,
          skillName: selectedKnowledgeArea?.label || "",
          skillTopicName: selectedTopic?.label || "",
        };
      } else if (currentType === 13) {
        request_data = {
          tenantId: parseInt(details?.tenentId),
          questionTypeID: currentType,
          name: questionTitle,
          description: questionDescription,
          duration: timeDuration,
          difficultyLevelId: selectDifficulty,
          weightage: questionWeightage,
          tags: tags.map((t) => t.value),
          skillId: selectedKnowledgeArea?.value,
          skillTopicId: selectedTopic?.value,
          skillName: selectedKnowledgeArea?.label || "",
          skillTopicName: selectedTopic?.label || "",
          languages: autoLanguages,

          data: JSON.stringify({
            execution_mode: "NotebookExecution",

            starter_notebook: starterNotebookUrl || null,

            datasets: {
              train: trainDatasetUrl || null,
              test: testDatasetUrl || null,
              evaluate: evaluateDatasetUrl || null,
              sample_output: sampleOutputUrl || null,
            },
            // metric: {
            //     type: selectedMetricType,
            //     target_column: targetColumn?.value || "",
            //     id_column: idColumn?.value || "",
            //     threshold: threshold,
            // }
            metric: {
              category: selectedCategory?.value,
              metric_type: selectedMetricType,
              ...(isThresholdVisible && { threshold }),
              target_column: targetColumn?.value || "",
              id_column: idColumn?.value || "",
            },
          }),
        };
      } else {
        request_data = {
          tenantId: parseInt(details?.tenentId),
          questionTypeID: currentType,
          name: questionTitle,
          description: questionDescription,
          outputReturnTypeId: selectOutput,
          duration: timeDuration,
          difficultyLevelId: selectDifficulty,
          weightage: questionWeightage,
          languages: programmingLanguages.map(
            (el) => [{ codingLanguageId: el.value }][0],
          ),
          inputs: inputs,
          tags: tags.map((el) => el.value),
          testCases: testCases,
          functionName: funcName,
          addFromList: props.addFromList ? true : null,
          skillId: selectedKnowledgeArea?.value || 0,
          skillTopicId: selectedTopic?.value || 0,
          skillName: selectedKnowledgeArea?.label || "",
          skillTopicName: selectedTopic?.label || "",
        };
      }
      if (location?.state?.edit) {
        request_data.id = location?.state?.detail?.id;
        const response = await dispatch(
          postUpdateCodingQuestion({
            ...request_data,
            id: location.state.detail?.id,
          }),
        );
        if (response.type === "UPDATE_CODING_QUESTION") {
          await dispatch(clearCreateQuestionState());
          navigate(-1);
          return response;
        }
      } else {
        const response = await dispatch(postCreateCodingQuestion(request_data));
        if (response?.type === "CREATE_CODING_QUESTION") {
          await dispatch(clearCreateQuestionState());
          props.addFromList ? props.goBack() : navigate(-1);
          return response;
        }
      }
      await setLoading(false);
    }
    await setLoading(false);
  };

  const handleSaveAndTry = async () => {

    let res;
    try {
      res = await questionSaveHandler();
    } catch (err) {
      console.error(" questionSaveHandler threw error:", err);
      return;
    }

    const id = res?.payload?.question?.id || res?.payload?.id || res?.payload?.questionID;
    if (!id) {
      return;
    }

    const url = `/try-coding/${id}`;
    window.open(url, "_blank");
  };

  const resetStates = () => {
    setQuestionTitle("");
    setQuestionDescription("");
    setProgrammingLanguages([]);
    setQuestionWeightage(20);
    setTimeDuration(10);
    setSelectOutput(1);
    setSelectDifficulty(1);
    setTags([]);
    setInputs([{ inputName: "n", inputTypeId: 1 }]);
    setTestCases([
      { isDefault: 1, output: "", inputs: [{ input: "" }] },
      { isDefault: 0, output: "", inputs: [{ input: "" }] },
    ]);
  };

  useEffect(() => {
    const firstRender = async () => {
      if (location?.state?.detail?.id) {
        await dispatch(resetCodingQuestionById());
        setTimeout(async () => {
          await dispatch(getCodingQuestionByID(location.state.detail.id));
        }, 0);
      }

      await Promise.all([
        dispatch(getCodingQuestionLanguages()),
        dispatch(getCodingQuestionReturnTypes()),
        dispatch(getQuestionTypes()),
        dispatch(getQuestionLevels()),
      ]);
    };

    firstRender();
  }, []);

  useEffect(() => {
    if (currentEditMode && currentDetail?.skillId && !hydratedRef.current) {
      hydratedRef.current = true;

      setSelectedKnowledgeArea({
        label: currentDetail.skillName,
        value: currentDetail.skillId,
      });

      setSelectedTopic({
        label: currentDetail.skillTopicName,
        value: currentDetail.skillTopicId,
      });
      dispatch(getSkillTopics(0, currentDetail.skillId));
    }
  }, [currentEditMode, currentDetail]);

  useEffect(() => {
    if (!codingQuestionByIdResponse || metricLoaded) return;

    const question = codingQuestionByIdResponse.question;
    if (!question || question.questionTypeID !== 13) return;

    try {
      const ds = JSON.parse(question.data);

      // ----- ONLY RUN after evaluateColumns are loaded -----
      if (evaluateColumns.length === 0) return;

      // Load category
      const categoryObj = metricCategoriesData.metric_categories.find(
        (c) => c.category === ds.metric.category,
      );

      if (categoryObj) {
        setSelectedCategory({
          label: categoryObj.category,
          value: categoryObj.category,
        });

        setCategoryDescription(categoryObj.description);
        setIsThresholdVisible(categoryObj.show_threshold);

        setAvailableMetrics(
          categoryObj.metrics.map((m) => ({
            label: m.metric_name,
            value: m.metric_code,
            description: m.description,
          })),
        );

        // Threshold
        if (categoryObj.show_threshold) {
          setThreshold(
            ds.metric.threshold ?? categoryObj.default_threshold ?? 0.5,
          );
        } else {
          setThreshold(null);
        }
      }

      // Metric
      const catMetrics = categoryObj?.metrics;
      const metricObj = catMetrics?.find(
        (m) => m.metric_code === ds.metric.metric_type,
      );

      if (metricObj) {
        setSelectedMetric({
          label: metricObj.metric_name,
          value: metricObj.metric_code,
          description: metricObj.description,
        });
        setSelectedMetricType(metricObj.metric_code);
        setMetricDescription(metricObj.description);
      }

      // Target column & ID column (EVEN IF EMPTY)
      setTargetColumn({
        label: ds.metric.target_column,
        value: ds.metric.target_column,
      });

      setIdColumn({
        label: ds.metric.id_column,
        value: ds.metric.id_column,
      });

      setMetricLoaded(true);
    } catch (err) {
      console.error("Error loading type13 metric details", err);
    }
  }, [codingQuestionByIdResponse, evaluateColumns]);

  const handleKnowledgeAreaChange = async (selectedArea) => {
    setSelectedKnowledgeArea(selectedArea);
    setSelectedTopic(null);

    if (!selectedArea) {
      dispatch(emptyTopics());
      return;
    }

    if (selectedArea.__isNew__) {
      dispatch(emptyTopics());
      return;
    }

    try {
      setLoading(true);
      await dispatch(getSkillTopics(0, selectedArea.value));
    } catch (err) {
      console.error("Failed to load topics for Knowledge Area", err);
    } finally {
      setLoading(false);
    }
  };

  const extractCSVColumns = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const text = reader.result;
        const firstLine = text.split("\n")[0];
        const cols = firstLine.split(",").map((col) => col.trim());
        resolve(cols);
      };
      reader.onerror = reject;
      reader.readAsText(file);
    });
  };

  const handleFileChange = async (e, setFileState, onSuccess, onFail) => {
    const file = e.target.files[0];
    if (!file) {
      return;
    }
    setFileState(file);
    setLoading(true);
    const res = await dispatch(uploadCodingQuestionFile(file));
    setLoading(false);
    if (res?.url) {
      onSuccess(res.url);
      return;
    }
    setFileState(null);
    e.target.value = "";
    onFail && onFail();
  };

  const extractCSVColumnsFromUrl = async (url) => {
    try {
      const response = await fetch(url);
      const text = await response.text();
      const firstLine = text.split("\n")[0];
      return firstLine.split(",").map((col) => col.trim());
    } catch (err) {
      console.error("Error loading columns from URL", err);
      return [];
    }
  };

  const isLoading =
    loading ||
    ((location?.state?.view || location?.state?.edit) &&
      loadingCodingQuestionById);

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
        }}
      >
        <div
          className="spinner-border"
          role="status"
          style={{ width: "3rem", height: "3rem", color: "#f75891" }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div
        className={
          isEmbedded
            ? ""
            : "bg-white rounded m-3 px-5 py-3 create-question-main"
        }
      >
        {!isEmbedded && (
          <>
            <div>
              <div className="d-flex">
                <img
                  src="/images/back.svg"
                  alt=""
                  className="cursor-pointer"
                  onClick={handleBack}
                />
                &nbsp;&nbsp;
                <h1 className="maintxt">
                  {" "}
                  {location?.state?.view
                    ? "View Question"
                    : location?.state?.edit
                      ? "Edit Question"
                      : "Create Question"}
                </h1>
              </div>
            </div>
            <br />
          </>
        )}

        <div className="row mt-4">
          <div className="col-md-6 col-12">
            <Stack spacing={2}>
              <div>
                <label className="labeltext px-0">Knowledge Area*</label>
              </div>
              <div className="mt-2">
                <CreatableSelect
                  isClearable
                  placeholder="Select Knowledge Area"
                  options={
                    skills?.map((el) => ({
                      label: el.label || el.knowledgeAreaName || el.skillName,
                      value: el.value || el.knowledgeAreaId || el.skillId,
                    })) || []
                  }
                  value={selectedKnowledgeArea}
                  onChange={(e) => handleKnowledgeAreaChange(e)}
                  onCreateOption={(inputValue) => {
                    const newKA = {
                      label: inputValue,
                      value: 0,
                      __isNew__: true,
                    };

                    setSelectedKnowledgeArea(newKA);
                    setSelectedTopic(null);
                    dispatch(emptyTopics());
                  }}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                  isDisabled={isViewMode}
                />
              </div>
            </Stack>
          </div>
          <div className="col-md-6 col-12">
            <Stack spacing={2}>
              <div>
                <label className="labeltext px-0">Topics*</label>
              </div>
              <div className="mt-2">
                <CreatableSelect
                  isClearable
                  placeholder="Select Topic"
                  options={
                    topics?.map((el) => ({
                      label: el.label || el.topicName || el.skillTopicName,
                      value: el.value || el.topicId || el.skillTopicId,
                    })) || []
                  }
                  value={selectedTopic}
                  onChange={(e) => setSelectedTopic(e)}
                  onCreateOption={(inputValue) => {
                    setSelectedTopic({
                      label: inputValue,
                      value: 0,
                      __isNew__: true,
                    });
                  }}
                  isDisabled={
                    (isCreateMode && !selectedKnowledgeArea) || isViewMode
                  }
                />
              </div>
            </Stack>
          </div>
        </div>

        <Stack spacing={5}>
          <div className="form-group mt-3">
            <label className="labeltext px-0">Question Name*</label>
            <input
              type="text"
              required
              value={questionTitle}
              maxLength={200}
              className="form-control mt-1"
              onChange={(e) => {
                setQuestionTitle(e.target.value);
              }}
              disabled={isViewMode}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <label className="labeltext px-0">Question Description*</label>
            <div className="row mb-2">
              <div className="col-12">
                <input
                  ref={imageInputRef}
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  style={{ display: "none" }}
                />
                <JoditEditor
                  config={{
                    ...joditConfig,
                    placeholder: questionDescription ? "" : "Start writing...",
                  }}
                  ref={descriptionEditorRef}
                  value={questionDescription}
                  onBlur={(newContent) => {
                    setQuestionDescription(newContent);
                    setQuestionDescriptionError("");
                  }}
                  isDisabled={isViewMode}
                />
                {questionDescriptionError && (
                  <small style={{ color: "red" }}>
                    {questionDescriptionError}
                  </small>
                )}
              </div>
            </div>
          </div>
          {currentType === 7 && (
            <Stack spacing={2}>
              <div>
                <label className="labeltext px-0">Function Name*</label>
              </div>
              <div className="mt-2">
                <input
                  type="text"
                  value={funcName}
                  className="form-control mt-2"
                  disabled={isViewMode}
                  onChange={(e) => {
                    const noSpaces = e.target.value.replace(/\s+/g, "");
                    setFuncName(noSpaces);
                  }}
                />
              </div>
            </Stack>
          )}

          {currentType !== 13 && (
            <Stack spacing={2}>
              <div>
                <label className="labeltext px-0">
                  {currentType === 12
                    ? "Database Languages"
                    : "Programming Languages"}
                  *
                </label>
              </div>
              <div className="mt-2">
                <Select
                  isMulti={currentType === 7}
                  placeholder="Select Languages"
                  options={
                    codingQuestionLanguagesOptions
                      ?.filter(
                        (lang) =>
                          lang.category?.id === (currentType === 12 ? 2 : 1),
                      )
                      ?.map((el) => ({
                        label: el.displayLanguage,
                        value: el.id,
                      })) || []
                  }
                  value={programmingLanguages}
                  onChange={(e) => {
                    if (currentType === 12) {
                      setProgrammingLanguages(e ? [e] : []);
                    } else {
                      setProgrammingLanguages(e || []);
                    }
                  }}
                  isDisabled={isViewMode}
                />
              </div>
            </Stack>
          )}
          <Stack spacing={2}>
            <div>
              <label className="labeltext px-0">Tags*</label>
            </div>
            <div className="mt-2">
              <CreatableSelect
                options={qTags}
                isMulti
                value={tags}
                placeholder="Enter tags"
                onChange={(e) => handleTags(e)}
                isDisabled={isViewMode}
              />
            </div>
          </Stack>
        </Stack>
        <br />

        <Box
          sx={{ flexGrow: 2, display: "flex", alignItems: "baseline", gap: 1 }}
        >
          <FormControl
            sx={{ m: 1, width: 250 }}
            variant="outlined"
            size="small"
          >
            <div>
              <label className="labeltext px-0">Time* (Minutes)</label>
              <input
                type="number"
                value={timeDuration}
                min={1}
                className="form-control mt-2"
                style={{ padding: 8 }}
                disabled={isViewMode}
                onChange={(e) => {
                  const val = e.target.value;

                  // ✅ allow empty while typing
                  if (val === "") {
                    setTimeDuration("");
                    return;
                  }

                  setTimeDuration(Number(val));
                }}
                onBlur={() => {
                  // ✅ enforce rule ONLY on blur
                  if (timeDuration === "" || timeDuration <= 0) {
                    setTimeDuration(1);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "-" || e.key === "e") {
                    e.preventDefault();
                  }
                }}
              />
            </div>
          </FormControl>
          <FormControl
            sx={{ m: 1, width: 250 }}
            variant="outlined"
            size="small"
          >
            <div>
              <label className="labeltext px-0">Score* (Marks)</label>
              <input
                type="number"
                value={questionWeightage}
                min={1}
                className="form-control mt-2"
                style={{ padding: 8 }}
                disabled={isViewMode}
                onChange={(e) => {
                  const val = e.target.value;

                  if (val === "") {
                    setQuestionWeightage("");
                    return;
                  }

                  setQuestionWeightage(Number(val));
                }}
                onBlur={() => {
                  if (questionWeightage === "" || questionWeightage <= 0) {
                    setQuestionWeightage(1);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "-" || e.key === "e") {
                    e.preventDefault();
                  }
                }}
              />
            </div>
          </FormControl>
        </Box>
        <br />
        <Box
          sx={{ flexGrow: 2, display: "flex", alignItems: "baseline", gap: 1 }}
        >
          {currentType === 7 && (
            <FormControl
              sx={{ m: 1, width: 250 }}
              variant="outlined"
              size="small"
            >
              <label className="labeltext px-0" id="output-simple-select-label">
                Output* (Return type)
              </label>
              <div className="mt-2">
                <select
                  defaultValue={0}
                  labelId="output-simple-select-label"
                  id="output-simple-select"
                  className="form-control"
                  value={selectOutput}
                  onChange={(event) =>
                    handleSelectChange(UI_STRINGS.OUTPUT, event)
                  }
                  disabled={isViewMode}
                >
                  {codingQuestionReturnTypesOptions?.returnTypes?.map(
                    (option, i) => {
                      return (
                        <option key={i} value={option?.id}>
                          {option?.retrunType}
                        </option>
                      );
                    },
                  )}
                </select>
              </div>
            </FormControl>
          )}
          <FormControl
            sx={{ m: 1, width: 250 }}
            variant="outlined"
            size="small"
          >
            <div>
              <label className="labeltext px-0" id="level-simple-select-label">
                Difficulty* (Level)
              </label>
            </div>
            <div className="mt-2">
              <select
                defaultValue={0}
                labelId="level-simple-select-label"
                id="level-simple-select"
                className="form-control"
                value={selectDifficulty}
                onChange={(event) =>
                  handleSelectChange(UI_STRINGS.DIFFICULTY, event)
                }
                disabled={isViewMode}
              >
                {questionLevel?.map((option, i) => {
                  return (
                    <option key={i} value={option?.questionLevelID}>
                      {option?.questionLevelName}
                    </option>
                  );
                })}
              </select>
            </div>
          </FormControl>
        </Box>
        <br />

        {currentType === 7 && (
          <Box sx={{ flexGrow: 1 }}>
            <div className="form-group mt-3">
              <label className="labeltext px-0">Inputs*</label>
              {inputs?.map((input, i) => {
                return (
                  <Box
                    key={i}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    {" "}
                    <FormControl
                      sx={{ m: 1, width: 250 }}
                      variant="outlined"
                      size="small"
                    >
                      <TextField
                        id="input-basic"
                        label="Input name"
                        required
                        variant="outlined"
                        size="small"
                        value={input?.inputName}
                        onBlur={() => validateInputOnBlur(input, i)}
                        onChange={(event) =>
                          handleInputs(i, "inputName", event)
                        }
                        disabled={isViewMode}
                      />
                    </FormControl>
                    <FormControl
                      required
                      sx={{ m: 1, minWidth: 250 }}
                      variant="outlined"
                      size="small"
                    >
                      <select
                        placeholder=""
                        defaultValue={1}
                        className="select-input form-control"
                        labelId="input-type-simple-select-label"
                        label="Input type"
                        id="input-type-simple-select"
                        value={input?.inputTypeId}
                        onChange={(event) =>
                          handleInputs(i, "inputTypeId", event)
                        }
                        disabled={isViewMode}
                      >
                        {codingQuestionReturnTypesOptions?.returnTypes?.map(
                          (option, i) => {
                            return (
                              <option key={i} value={option?.id}>
                                {option?.retrunType}
                              </option>
                            );
                          },
                        )}
                      </select>
                    </FormControl>
                    {i !== 0 && (
                      <IconButton
                        onClick={() => deleteInputHandler(i)}
                        aria-label="delete"
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </Box>
                );
              })}
              <Button
                style={{ color: "#009199", fontWeight: "bold" }}
                onClick={() =>
                  setInputs([...inputs, { inputName: "", inputTypeId: 1 }])
                }
                variant="outlined"
              >
                Add more input
              </Button>
            </div>
          </Box>
        )}
        {currentType === 13 && (
          <>
            {/* Starter Notebook */}
            <div className="form-group mt-3">
              <label className="labeltext col-form-label">
                Starter Notebook (.ipynb)*
              </label>
              <div className="dataset-row">
                <div className="dataset-label">
                  This will be used for notebook and scoring.
                </div>

                {!starterNotebookUrl ? (
                  <label className="upload-btn">
                    <img
                      src="/images/upload-icon-black.svg"
                      width={20}
                      alt=""
                    />
                    UPLOAD IPYNB
                    <input
                      type="file"
                      accept=".ipynb"
                      style={{ display: "none" }}
                      onChange={(e) =>
                        handleFileChange(
                          e,
                          setStarterNotebookFile,
                          (url) => setStarterNotebookUrl(url),
                          () => setStarterNotebookUrl(""),
                        )
                      }
                      isDisabled={isViewMode}
                    />
                  </label>
                ) : (
                  <div className="file-chip d-flex justify-content-between align-items-center">
                    <span>starternotebook.ipynb</span>
                    <div className="d-flex gap-2">
                      <img
                        src="/images/download-pink.svg"
                        alt="download"
                        className="cursor-pointer"
                        width={20}
                        onClick={() => downloadFile(starterNotebookUrl, "starternotebook.ipynb")}
                      />
                      {!isViewMode && (
                        <img
                          src="/images/delete-red.svg"
                          alt="remove"
                          className="cursor-pointer"
                          width={20}
                          onClick={() => setStarterNotebookUrl("")}
                        />
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Datasets Editor */}
            <h4 className="labeltext mt-4 col-form-label">Datasets</h4>
            {/* Train Dataset */}
            <div className="form-group">
              <label className="labeltext col-form-label">Train Dataset*</label>
              <div className="dataset-row">
                <div className="dataset-label">
                  This can be used to train models in the solution.
                </div>

                {!trainDatasetUrl ? (
                  <label className="upload-btn">
                    <img
                      src="/images/upload-icon-black.svg"
                      width={20}
                      alt=""
                    />
                    UPLOAD CSV
                    <input
                      type="file"
                      accept=".csv"
                      style={{ display: "none" }}
                      onChange={(e) =>
                        handleFileChange(
                          e,
                          setTrainDatasetFile,
                          (url) => setTrainDatasetUrl(url),
                          () => setTrainDatasetUrl(""),
                        )
                      }
                      isDisabled={isViewMode}
                    />
                  </label>
                ) : (
                  <div className="file-chip d-flex justify-content-between align-items-center">
                    <span>train.csv</span>
                    <div className="d-flex gap-2">
                      <img
                        src="/images/download-pink.svg"
                        alt="download"
                        className="cursor-pointer"
                        width={20}
                        onClick={() => downloadFile(trainDatasetUrl, "train.csv")}
                      />
                      {!isViewMode && (
                        <img
                          src="/images/delete-red.svg"
                          alt="remove"
                          className="cursor-pointer"
                          width={20}
                          onClick={() => setTrainDatasetUrl("")}
                        />
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Test Dataset */}
            <div className="form-group mt-3">
              <label className="labeltext col-form-label">Test Dataset*</label>
              <div className="dataset-row">
                <div className="dataset-label">
                  This will be used for evaluation and scoring.
                </div>

                {!testDatasetUrl ? (
                  <label className="upload-btn">
                    <img
                      src="/images/upload-icon-black.svg"
                      width={20}
                      alt=""
                    />
                    UPLOAD CSV
                    <input
                      type="file"
                      accept=".csv"
                      style={{ display: "none" }}
                      onChange={(e) =>
                        handleFileChange(
                          e,
                          setTestDatasetFile,
                          (url) => setTestDatasetUrl(url),
                          () => setTestDatasetUrl(""),
                        )
                      }
                      isDisabled={isViewMode}
                    />
                  </label>
                ) : (
                  <div className="file-chip d-flex justify-content-between align-items-center">
                    <span>test.csv</span>
                    <div className="d-flex gap-2">
                      <img
                        src="/images/download-pink.svg"
                        alt="download"
                        className="cursor-pointer"
                        width={20}
                        onClick={() => downloadFile(testDatasetUrl, "test.csv")}
                      />
                      {!isViewMode && (
                        <img
                          src="/images/delete-red.svg"
                          alt="remove"
                          className="cursor-pointer"
                          width={20}
                          onClick={() => setTestDatasetUrl("")}
                        />
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Evaluate Dataset */}
            <div className="form-group mt-3">
              <label className="labeltext col-form-label">
                Evaluate Dataset*
              </label>
              <div className="dataset-row">
                <div className="dataset-label">
                  This can be used to verify and validate models in solution
                  verification.
                </div>

                {!evaluateDatasetUrl ? (
                  <label className="upload-btn">
                    <img
                      src="/images/upload-icon-black.svg"
                      width={20}
                      alt=""
                    />
                    UPLOAD CSV
                    <input
                      type="file"
                      accept=".csv"
                      style={{ display: "none" }}
                      onChange={async (e) => {
                        const file = e.target.files[0];
                        setEvaluateFile(file);

                        await handleFileChange(
                          e,
                          setEvaluateDatasetFile,
                          (url) => setEvaluateDatasetUrl(url),
                          () => setEvaluateDatasetUrl(""),
                        );

                        if (!file) {
                          setEvaluateColumns([]);
                          return;
                        }

                        const cols = await extractCSVColumns(file);

                        if (cols?.length > 0) {
                          setEvaluateColumns(
                            cols.map((c) => ({ label: c, value: c })),
                          );
                        } else {
                          setEvaluateColumns([]);
                          returnErrors(
                            dispatch,
                            "No columns found in Evaluate CSV!",
                            500,
                          );
                        }
                      }}
                      isDisabled={isViewMode}
                    />
                  </label>
                ) : (
                  <div className="file-chip d-flex justify-content-between align-items-center">
                    <span>evaluate.csv</span>
                    <div className="d-flex gap-2">
                      <img
                        src="/images/download-pink.svg"
                        alt="download"
                        className="cursor-pointer"
                        width={20}
                        onClick={() => downloadFile(evaluateDatasetUrl, "evaluate.csv")}
                      />
                      {!isViewMode && (
                        <img
                          src="/images/delete-red.svg"
                          alt="remove"
                          className="cursor-pointer"
                          width={20}
                          onClick={() => {
                            setEvaluateDatasetUrl("");
                            setEvaluateColumns([]);
                          }}
                        />
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* outputs */}
            <h4 className="labeltext mt-4 col-form-label">Output</h4>
            {/* Sample Output Dataset */}
            <div className="form-group mt-3">
              <label className="labeltext col-form-label">Sample Output</label>
              <div className="dataset-row">
                <div className="dataset-label">
                  This dataset is used to show sample expected output.
                </div>

                {!sampleOutputUrl ? (
                  <label className="upload-btn">
                    <img
                      src="/images/upload-icon-black.svg"
                      width={20}
                      alt=""
                    />
                    UPLOAD CSV
                    <input
                      type="file"
                      accept=".csv"
                      style={{ display: "none" }}
                      onChange={(e) =>
                        handleFileChange(
                          e,
                          setSampleOutputFile,
                          (url) => setSampleOutputUrl(url),
                          () => setSampleOutputUrl(""),
                        )
                      }
                      isDisabled={isViewMode}
                    />
                  </label>
                ) : (
                  <div className="file-chip d-flex justify-content-between align-items-center">
                    <span>sampleoutput.csv</span>
                    <div className="d-flex gap-2">
                      <img
                        src="/images/download-pink.svg"
                        alt="download"
                        className="cursor-pointer"
                        width={20}
                        onClick={() => downloadFile(sampleOutputUrl, "sampleoutput.csv")}
                      />
                      {!isViewMode && (
                        <img
                          src="/images/delete-red.svg"
                          alt="remove"
                          className="cursor-pointer"
                          width={20}
                          onClick={() => setSampleOutputUrl("")}
                        />
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Evaluation Settings */}
            <h4 className="labeltext mt-4 col-form-label">
              Evaluation Settings
            </h4>

            {/* Target Column dropdown (will be CSV headers later) */}
            <div className="form-group mt-3">
              <label className="labeltext col-form-label">Target Column*</label>

              <Select
                placeholder="Select Target Column"
                value={targetColumn}
                options={evaluateColumns}
                isClearable
                onChange={(v) => setTargetColumn(v)}
                onMenuOpen={() => {
                  if (!evaluateFile) {
                    returnErrors(
                      dispatch,
                      "Upload Evaluate Dataset to load columns!",
                      500,
                    );
                  }
                }}
                isDisabled={!evaluateFile && isViewMode}
              />
            </div>

            {/* ID Column dropdown */}
            <div className="form-group mt-3 mb-3">
              <label className="labeltext col-form-label">ID Column*</label>
              <Select
                placeholder="Select ID Column"
                value={idColumn}
                options={evaluateColumns}
                isClearable
                onChange={(v) => setIdColumn(v)}
                onMenuOpen={() => {
                  if (!evaluateFile) {
                    returnErrors(
                      dispatch,
                      "Upload Evaluate Dataset to load columns!",
                      500,
                    );
                  }
                }}
                isDisabled={!evaluateFile && isViewMode}
              />
            </div>

            {/* Metric Type */}
            {/* CATEGORY DROPDOWN */}
            <div className="form-group mt-3">
              <label className="labeltext col-form-label">Category*</label>

              <Select
                placeholder="Select Category"
                value={selectedCategory}
                options={metricCategoriesData.metric_categories.map((cat) => ({
                  label: cat.category,
                  value: cat.category,
                }))}
                onChange={(selected) => {
                  setSelectedCategory(selected);

                  const categoryObj =
                    metricCategoriesData.metric_categories.find(
                      (c) => c.category === selected.value,
                    );

                  // ---- FIX #4: Set threshold BEFORE visibility ----
                  if (categoryObj.show_threshold) {
                    setThreshold(categoryObj.default_threshold ?? 0.5);
                  } else {
                    setThreshold(null);
                  }

                  setIsThresholdVisible(categoryObj.show_threshold);

                  setCategoryDescription(categoryObj.description);

                  // Load metrics for selected category
                  setAvailableMetrics(
                    categoryObj.metrics.map((m) => ({
                      label: m.metric_name,
                      value: m.metric_code,
                      description: m.description,
                    })),
                  );

                  // Reset previously selected metric
                  setSelectedMetric(null);
                  setSelectedMetricType("");
                  setMetricDescription("");
                }}
                isDisabled={isViewMode}
              />

              {categoryDescription && (
                <p className="text-muted mt-2">{categoryDescription}</p>
              )}
            </div>

            {/* METRIC TYPE DROPDOWN */}
            {selectedCategory && (
              <div className="form-group mt-3">
                <label className="labeltext col-form-label">Metric Type*</label>

                <Select
                  placeholder="Select Metric"
                  value={selectedMetric}
                  options={availableMetrics}
                  onChange={(opt) => {
                    setSelectedMetric(opt);
                    setSelectedMetricType(opt.value);
                    setMetricDescription(opt.description);
                  }}
                  isDisabled={isViewMode}
                />

                {metricDescription && (
                  <p className="text-muted mt-2">{metricDescription}</p>
                )}
              </div>
            )}

            {isThresholdVisible && (
              <div className="form-group mt-3">
                <label className="labeltext col-form-label">Threshold*</label>
                <input
                  type="number"
                  value={threshold ?? ""}
                  min={0}
                  className="form-control mt-2"
                  onChange={(e) => setThreshold(Number(e.target.value))}
                  disabled={isViewMode}
                />
              </div>
            )}

            {/* <div className="form-group">
                    <label className="labeltext col-form-label">Threshold*</label>
                    <input type='number' value={threshold} min={0} className='form-control mt-2' style={{ padding: 8 }} 
                            onChange={(e) => {
                                const value = Number(e.target.value);

                                if (value < 0) {
                                setThreshold(0);
                                } else {
                                setThreshold(value);
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "-" || e.key === "e") {
                                e.preventDefault();
                                }
                            }}
                        />
                </div> */}
          </>
        )}
      </div>

      {currentType === 12 ? (
        <div
          className={
            isEmbedded
              ? ""
              : "bg-white rounded m-3 px-5 py-3 create-question-main"
          }
        >
          <Stack spacing={4}>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <label className="labeltext px-0">Sample Solution</label>
              <div className="row mb-2">
                <div className="col-12">
                  {/* <JoditEditor
                            value={sampleSolution}
                            config={{...joditConfig, placeholder: sampleSolution ? '' : 'Start writing...'}}
                            onBlur={content => setSampleSolution(content)}
                            isDisabled={isViewMode}
                        /> */}
                  <SqlAceEditor
                    value={sampleSolution}
                    onChange={setSampleSolution}
                    readOnly={isViewMode}
                    height="150px"
                  />
                </div>
              </div>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <label className="labeltext px-0">Configuration*</label>
              <div className="row mb-2">
                <div className="col-12">
                  {/* <JoditEditor
                            value={configuration}
                            config={{...joditConfig, placeholder: configuration ? '' : 'Start writing...'}}
                            onBlur={content => setConfiguration(content)}
                            isDisabled={isViewMode}
                        /> */}
                  <SqlAceEditor
                    value={configuration}
                    onChange={setConfiguration}
                    readOnly={isViewMode}
                    height="150px"
                  />
                </div>
              </div>
            </div>
            <div>
              <label className="labeltext px-0">Test Cases*</label>
              {dbTestCases.map((tc, idx) => (
                <Box
                  key={idx}
                  sx={{
                    border: "1px solid #ddd",
                    borderRadius: 2,
                    padding: 2,
                    marginBottom: 2,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 10,
                    }}
                  >
                    <Typography variant="subtitle1">
                      Test Case {idx + 1}
                    </Typography>
                    <div className="row mb-2">
                      <div className="col-12">
                        {/* <JoditEditor
                                    value={tc.sqlQuery}
                                    config={{...joditConfig, placeholder: tc.sqlQuery ? '' : 'Start writing...'}}
                                    onBlur={(val) => {
                                        const updated = [...dbTestCases];
                                        updated[idx].sqlQuery = val;
                                        setDbTestCases(updated);
                                    }}
                                    disabled={isViewMode}
                                /> */}
                        <SqlAceEditor
                          value={tc.sqlQuery}
                          onChange={(value) =>
                            handleDbTestCaseChange(idx, value)
                          }
                          readOnly={isViewMode}
                          height="120px"
                        />
                      </div>
                    </div>
                  </div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={tc.isSample}
                        onChange={(e) => {
                          const updated = dbTestCases.map((test, i) => ({
                            ...test,
                            isSample: i === idx ? e.target.checked : false,
                          }));
                          setDbTestCases(updated);
                        }}
                      />
                    }
                    label="Is sample testcase?"
                  />
                  {idx > 0 && (
                    <IconButton
                      onClick={() => {
                        const updated = [...dbTestCases];
                        updated.splice(idx, 1);
                        setDbTestCases(updated);
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </Box>
              ))}
              <Button
                style={{ color: "#009199", fontWeight: "bold" }}
                onClick={() =>
                  setDbTestCases([
                    ...dbTestCases,
                    { sqlQuery: "", isSample: false },
                  ])
                }
                variant="outlined"
                disabled={isViewMode}
              >
                Add more test cases
              </Button>
            </div>
          </Stack>
        </div>
      ) : currentType === 7 ? (
        <div
          className={
            isEmbedded
              ? ""
              : "bg-white rounded m-3 px-5 py-3 create-question-main"
          }
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              cursor: "pointer",
            }}
            onClick={handleExpandClick}
          >
            <ExpandMore
              expand={expanded?.toString()}
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show test cases"
            >
              {" "}
              <ExpandMoreIcon />
            </ExpandMore>

            <h3 className="text-start" style={{ color: "black" }}>
              Test Cases*
            </h3>
          </Box>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <CardContent>
              {testCases?.map((testCase, index) => {
                return (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      border: "1px solid",
                      borderColor: "divider",
                      borderRadius: 2,
                      gap: 2,
                      bgcolor: "background.paper",
                      padding: 2,
                      marginBlock: 1,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        gap: 3,
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <h6 className="text-start">'Test case {index + 1}</h6>
                      <div>
                        {index > 1 && (
                          <IconButton
                            onClick={() => {
                              let testCases_copy = [...testCases];
                              testCases_copy.splice(index, 1);
                              setTestCases(testCases_copy);
                            }}
                            aria-label="delete"
                          >
                            <DeleteIcon />
                          </IconButton>
                        )}
                      </div>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        flexWrap: "wrap",
                      }}
                    >
                      {inputs?.map((input_, i) => {
                        return (
                          <Box
                            key={i}
                            sx={{
                              display: "flex",
                              gap: 2,
                              alignItems: "end",
                            }}
                          >
                            <FormControl
                              sx={{ m: 1, minWidth: 150 }}
                              variant="outlined"
                              size="small"
                            >
                              <Typography>
                                Input name {i + 1} : {input_?.inputName}
                              </Typography>
                            </FormControl>
                            <FormControl
                              sx={{ m: 1, width: 250, mr: 10 }}
                              variant="outlined"
                              size="small"
                            >
                              <TextField
                                id="input-basic"
                                type="text"
                                required
                                variant="outlined"
                                size="small"
                                value={testCase?.inputs[i]?.input}
                                onChange={(event) =>
                                  handleTestCase(index, i, "input", event)
                                }
                                disabled={isViewMode}
                              />
                            </FormControl>
                          </Box>
                        );
                      })}
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        gap: 2,
                        alignItems: "end",
                      }}
                    >
                      <FormControl
                        sx={{ m: 1, width: 150 }}
                        variant="outlined"
                        size="small"
                      >
                        <Typography>Output</Typography>
                      </FormControl>
                      <FormControl
                        sx={{ m: 1, width: 250 }}
                        variant="outlined"
                        size="small"
                      >
                        <TextField
                          id="input-basic"
                          required
                          variant="outlined"
                          size="small"
                          value={testCase?.output}
                          onChange={(event) =>
                            testCaseOutputChangeHandler(index, event)
                          }
                          disabled={isViewMode}
                        />
                      </FormControl>
                    </Box>
                    <FormControlLabel
                      control={
                        <Checkbox
                          size="small"
                          checked={testCase?.isDefault ? true : false}
                          onChange={(event) =>
                            defaultTestCaseChangeHandler(index, event)
                          }
                        />
                      }
                      label="Default"
                    />
                  </Box>
                );
              })}
            </CardContent>
          </Collapse>
          {expanded && (
            <Button
              style={{ color: "#009199", fontWeight: "bold", paddingLeft: "0" }}
              onClick={() =>
                setTestCases([
                  ...testCases,
                  { isDefault: 0, inputs: [{ input: "" }] },
                ])
              }
              variant="outlined"
              disabled={isViewMode}
            >
              Add more test cases
            </Button>
          )}
        </div>
      ) : null}

      <div className="d-flex gap-3">
        {currentType === 12 && (
          <button
            style={save_button_style}
            onClick={() => {
              if (location?.state?.view) {
                const id = location?.state?.detail?.id;
                if (id) {
                  window.open(`/try-coding/${id}`, "_blank");
                }
              } else {
                questionSaveHandler();
              }
            }}
            disabled={loading}
          >
            {location?.state?.view ? 'Try this problem' : 'Save & Try'}
          </button>
        )}
        {!location?.state?.view && (
          <div style={{ textAlign: "start", paddingLeft: "12px" }}>
            {" "}
            <button
              style={save_button_style}
              disabled={loading}
              onClick={() => questionSaveHandler()}
            >
              Save
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateCodingQuestion;
